export default __webpack_public_path__ + "static/media/powerButton.606488a1.svg";